/* eslint-disable jsx-a11y/anchor-is-valid, react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';

import Text from '../partials/Text';
import PeopleCard from '../cards/People';

import styles from '../../../styles/blocks/people.scss';

const propTypes = {
    intl: PropTypes.shape({
        locale: PropTypes.string,
    }).isRequired,
    title: PropTypes.objectOf(PropTypes.string),
    text: PropTypes.objectOf(PropTypes.string),
    items: PropTypes.arrayOf(PropTypes.shape({})),
    first: PropTypes.bool,
};

const defaultProps = {
    title: null,
    text: null,
    items: [],
    first: false,
};

const SectionPeopleBlock = ({ intl, first, ...props }) => {
    const { locale } = intl;
    const title = get(props, `title.${locale}`, null);
    const text = get(props, `text.${locale}`, null);
    const items = get(props, 'items', []);
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles.first]: first,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.header}>
                    {!isEmpty(title) ? (
                        <h1 className={styles.title}>
                            <Text inline>{title}</Text>
                        </h1>
                    ) : null}
                    {!isEmpty(text) ? (
                        <div className={styles.text}>
                            <Text>{text}</Text>
                        </div>
                    ) : null}
                </div>
                <div className={styles.items}>
                    {items.map((item, index) => (
                        <div key={`people-${index}`} className={styles.item}>
                            <hr />
                            <PeopleCard {...item} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

SectionPeopleBlock.propTypes = propTypes;
SectionPeopleBlock.defaultProps = defaultProps;

export default injectIntl(SectionPeopleBlock);



// WEBPACK FOOTER //
// ./js/components/blocks/SectionPeople.jsx